<template>
  <div class="main-wrap" >
    <!-- 中间四大块  上左-上右-下左-下右 -->
    <div
      class="safe-block"
      v-for="(item, index) in safeArr"
      :key="index"
    >
      <h1>
        <p>{{item.title}}</p>
        <p>{{item.title1}}</p>
      </h1>
      <ul>
        <li
          v-for="(item1, index1) in item.list"
          :key="index1"
          :class='["safe-block-con",item.position]'
        >{{item1.name}}</li>
      </ul>
    </div>
    <!-- 中间四大块对应的详情小块 -->
    <div class="safe-details-wrapper">
      <div
        :class='["safe-details",item.position]'
        v-for="item in detailData[detailIndex].safeDetailsArrL"
        :key="item.id"
      >
        <div class="safe-details-item-wrapper">
          <div
            v-for="(item1, index1) in item.details"
            :key="index1"
            class="safe-details-item"
          >
            <span class="safe-details-l">{{item1.name}}</span><span class="safe-details-r">{{item1.value}}</span>
          </div>
        </div>
      </div>
      <div
        :class='["safe-details",item.position]'
        v-for="item in detailData[detailIndex].safeDetailsArrR"
        :key="item.id"
      >
        <div class="safe-details-item-wrapper">
          <div
            v-for="(item1, index1) in item.details"
            :key="index1"
            class="safe-details-item"
          >
            <span class="safe-details-l">{{item1.name}}</span><span class="safe-details-r">{{item1.value}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间中心块文字 -->
    <div class="center-text">
      <h1 class="center-text-title">数据保险箱</h1>
    </div>
    <div class="circle-p circle-center"></div>
    <div class="circle-p circle-center-fill"></div>
    <div class="circle-p circle-center-fill2"></div>
    <div class="circle-p circle-center-fill3"></div>
    <div class="circle-p circle-outer2 "></div>
    <div class="circle-p circle-outer3"></div>
    <div class="circle-p circle-outer"></div>
    <div class="circle-p circle-bg"></div>

    <div>
      <div class="main-point"></div>
      <div class="main-point"></div>
      <div class="main-point"></div>
      <div class="main-point"></div>
    </div>
     <rect-line
      :box-style="{left:'390px',top:'20px',width:'1400px',height:'20px'}"
      :points="[[0, 10], [1400, 10]]"
    ></rect-line>
    <rect-line
      :box-style="{left:'90px',top:'450px',width:'20px',height:'300px'}"
      :points="[[10, 300],[10, 0]]"
    ></rect-line>
    <rect-line
      :box-style="{left:'90px',top:'1200px',width:'1940px',height:'60px'}"
      :points="[[1930, 0],[1930, 50],[10, 50],[10, 0]]"
    ></rect-line>
     <rect-line
      :box-style="{left:'2020px',top:'450px',width:'20px',height:'300px'}"
      :points="[[10, 0],[10, 300]]"
    ></rect-line>

    <dash-line
      :box-style="{left:'232px',top:'460px'}"
      :points="[[400, 84], [20, 84], [20, 0]]"
    ></dash-line>
    <dash-line
      :box-style="{right:'232px',top:'460px'}"
      :points="[[20, 84], [400, 84], [400, 0]]"
    ></dash-line>
    <dash-line
      :box-style="{left:'232px',top:'644px'}"
      :points="[[400, 20], [20, 20], [20, 104]]"
    ></dash-line>
    <dash-line
      :box-style="{right:'232px',top:'644px'}"
      :points="[[20, 20], [400, 20], [400, 104]]"
    ></dash-line>

  </div>
</template>
<script>
import dashLine from '../shapes/dashLine'
import rectLine from '../shapes/rectLine'
import { vueBus } from '../../assets/js/common/vueBus'
import zrender from 'zrender'
import { TimelineMax, Back,TweenMax } from 'gsap'
let timeInterval = null; // 获取详情卡片数据定时器
export default {
  data() {
    return {
      anima: '',
      safeArr: [
        {
          title: "生产企业MES系统",
          title1: "",
          position: "leftTop",
          list: [
            { name: "投料信息" },
            { name: "成品信息" },
            { name: "批次收率信息" },
          ],
        },
        {
          title: "企业LIMS系统",
          title1: "",
          position: "rightTop",
          list: [
            { name: "原辅料检验信息" },
            { name: "中间体检验信息" },
            { name: "成品检验信息" },
          ],
        },
        {
          title: "企业SCADA系统",
          title1: "",
          position: "leftBottom",
          list: [{ name: "工艺备案信息" }, { name: "关键工艺参数信息" }],
        },
        {
          title: "自主采集",
          title1: "",
          position: "rightBottom",
          list: [
            { name: "环境信息" },
            { name: "视频分析预警" },
            { name: "出入库信息" },
          ],
        },
      ],
      detailData: [
        {
          safeDetailsArrL: [
            {
              id: 0,
              position: "lt",
              details: [
                { name: "产品名称：", value: '人血白蛋白' },
                { name: "生产批号：", value: '20210521' },
                { name: "原料投入：", value: '150.0kg' },
                { name: "成品产出：", value: '149.7kg' },
                { name: "批次收率：", value: '99.8%' },
              ],
            },
            {
              id: 1,
              position: "rt",
              details: [
                { name: "原辅料检验报告：", value: '26个' },
                { name: "中间体检验报告：", value: '12个' },
                { name: "成品检验报告：", value: '1个' },
              ],
            },
          ],
          safeDetailsArrR: [
            {
              id: 2,
              position: "lb",
              details: [
                { name: "搅拌湿度：", value: '85℃' },
                { name: "井浆罐压力：", value: '25kPa' },
                { name: "灭菌温度：", value: '120℃' },
                { name: "灭菌时长：", value: '1h20Min' },
                { name: "灯检通过率：", value: '99.95%' },
              ],
            },
            {
              id: 3,
              position: "rb",
              details: [
                { name: "环境温度：", value: '25℃' },
                { name: "环境湿度：", value: '22%RH' },
                { name: "风速：", value: '0.514m/s' },
                { name: "视频预警：", value: '1条' },
                { name: "出入库信息：", value: '85条' },
              ],
            },
          ],
        },
        {
          safeDetailsArrL: [
            {
              id: 0,
              position: "lt",
              details: [
                { name: "产品名称：", value: '布洛芬胶囊' },
                { name: "生产批号：", value: '20210522A' },
                { name: "原料投入：", value: '300.0kg' },
                { name: "成品产出：", value: '298.8kg' },
                { name: "批次收率：", value: '99.6%' },
              ],
            },
            {
              id: 1,
              position: "rt",
              details: [
                { name: "原辅料检验报告：", value: '14个' },
                { name: "中间体检验报告：", value: '-' },
                { name: "成品检验报告：", value: '1个' },
              ],
            },
          ],
          safeDetailsArrR: [
            {
              id: 2,
              position: "lb",
              details: [
                { name: "搅拌湿度：", value: '50℃' },
                { name: "井浆罐压力：", value: '30kPa' },
                { name: "灭菌温度：", value: '80℃' },
                { name: "灭菌时长：", value: '0h20Min' },
                { name: "灯检通过率：", value: '-' },
              ],
            },
            {
              id: 3,
              position: "rb",
              details: [
                { name: "环境温度：", value: '20℃' },
                { name: "环境湿度：", value: '21%RH' },
                { name: "风速：", value: '0.534m/s' },
                { name: "视频预警：", value: '0条' },
                { name: "出入库信息：", value: '155条' },
              ],
            },
          ],
        },
      ],
      detailIndex: 0, // 详情卡片索引
    }
  },
  mounted() {
    let me = this
    vueBus.$on('imgOnload', v => {
      me.anima = v
    })
    // 获取详情卡片数据定时器
    if (timeInterval) {
      clearInterval(timeInterval);
    } else {
      timeInterval = setInterval(() => {
        if (this.detailIndex == 0) {
          this.detailIndex++; // 详情卡片索引
        } else {
          this.detailIndex--; // 详情卡片索引
        }
      }, 4000);
    }
  },
  beforeDestroy() {
    if (timeInterval) {
      clearInterval(timeInterval); // 获取详情卡片数据定时器
    }
  },
  watch: {
    anima(val, oldVal) {
      val == 'animateStart' && this.animate()
    }
  },
  methods: {
    animate() {
      var rotateTime = 2
      var translateTime =.8
      var tm1= new TimelineMax()
      var tm2= new TimelineMax()
      tm1.staggerFrom('.safe-block-con',4,{ rotationX: 180, opacity: 0, ease: Back.easeOut },0.1)
      tm2.staggerFrom('.safe-details',4,{ x: -200, opacity: 0, ease: Back.easeOut  },0.5)
    }
  },
  components: {
    dashLine,
    rectLine
  }
}
</script>
<style lang="scss" scoped>
.main-wrap {
  height: 100%;
  width: 100%;
  .safe-block {
    width: 390px;
    height: 457px;
    position: absolute;
    background: url("../../assets/imgs/box.png") center no-repeat;
    background-size: cover;

    &:nth-child(1) {
      top: 0;
      left: 0;
    }
    &:nth-child(2) {
      top: 0;
      right: 0;
    }
    &:nth-child(3) {
      bottom: 45px;
      left: 0;
    }
    &:nth-child(4) {
      bottom: 45px;
      right: 0;
    }
    h1 {
      padding-right: 60px;
      margin: 73px 0 40px 0;
      color: #fff;
      font-size: 36px;
      text-align: center;
    }
    ul {
      padding: 0 75px 0 15px;
      perspective: 400px;
      perspective-origin: 0% 50%;
      li {
        position: relative;
        width: 236px;
        height: 72px;
        margin: 15px 0;
        line-height: 72px;
        background: #02191c8f;
        border-radius: 15px;
        color: #fff;
        font-size: 24px;
        text-align: left;
        padding-left: 60px;
        &::before {
          position: absolute;
          top: 30px;
          left: 30px;
          content: "";
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #02DCFC;
          margin-right: 14px;
        }
      }
    }
  }
  .safe-details-wrapper {
    .safe-details {
      position: absolute;
      width: 379px;
      height: 259px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 20px;
      transform-origin: 50% 50%;
      background: url("../../assets/imgs/box-details-left.png") center no-repeat;
      &:nth-child(1) {
        left: 408px;
        top: 83px;
      }
      &:nth-child(2) {
        background: url("../../assets/imgs/box-details-right.png") center no-repeat;
        right: 408px;
        top: 83px;
      }
      &:nth-child(3) {
        left: 408px;
        bottom: 83px;
      }
      &:nth-child(4) {
        background: url("../../assets/imgs/box-details-right.png") center no-repeat;
        right: 408px;
        bottom: 83px;
      }
      .safe-details-item {
        margin: 9px 0;
        .safe-details-l {
          color: #fff;
          display: inline-block;
          width: 188px;
          text-align: right;
        }
        .safe-details-r {
          display: inline-block;
          margin-left: 15px;
          text-align: left;
          color: #02DCFC;
          font-style: italic;
        }
      }
    }
  }
  .main-point {
    position: absolute;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #00fffe;
    z-index: 10;
    animation: pointLight 1.1s cubic-bezier(0.73, 0.18, 1, 1) infinite alternate;
    &:nth-child(1) {
      top: 520px;
      left: 608px;
    }
    &:nth-child(2) {
      top: 640px;
      left: 608px;
    }
    &:nth-child(3) {
      top: 520px;
      right: 608px;
    }
    &:nth-child(4) {
      top: 640px;
      right: 608px;
    }
  }

  .circle-center {
    background: url("../../assets/imgs/circle/circle-center.png");
    z-index: 5;
    animation: clockwise 20s infinite linear;
  }
  .circle-center-fill {
    background: url("../../assets/imgs/circle/circle-center-fill.png");
    z-index: 6;
    animation: anticlockwise 40s infinite linear;
  }
  .circle-center-fill2 {
    background: url("../../assets/imgs/circle/circle-center-fill2.png");
    z-index: 8;
    animation: clockwise 60s infinite linear;
  }
  .circle-center-fill3 {
    background: url("../../assets/imgs/circle/circle-center-fill3.png");
    z-index: 9;
    animation: anticlockwise 80s infinite linear;
  }
  .circle-outer {
    background: url("../../assets/imgs/circle/circle-outer.png");
    z-index: 4;
    animation: clockwise 100s infinite linear;
    mix-blend-mode: color-dodge;
  }
  .circle-outer2 {
    background: url("../../assets/imgs/circle/circle-outer2.png");
    z-index: 3;
    mix-blend-mode: color-dodge;
  }
  .circle-outer3 {
    background: url("../../assets/imgs/circle/circle-outer3.png");
    z-index: 5;
    animation: clockwise 100s infinite linear;
    mix-blend-mode: color-dodge;
  }
  .circle-bg {
    border-radius: 50%;
    background: url("../../assets/imgs/center-bg.jpg");
    z-index: 3;
  }
  .circle-p {
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 50%;
    left: 50%;
    width: 734px;
    height: 734px;
    margin-top: -367px;
    margin-left: -367px;
  }
  @keyframes anticlockwise {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes clockwise {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }
  .center-text {
    position: absolute;
    width: 300px;
    height: 338px;
    top: 50%;
    left: 50%;
    margin-top: -169px;
    margin-left: -150px;
    z-index: 11;
    text-align: center;
    .center-text-title {
      color: #02dcfc;
      font-size: 50px;
      position: absolute;
      top: 129px;
      left: 25px;
      z-index: 1;
    }
    .center-text-list {
      width: 100%;
      margin-top: 30px;
      li:nth-child(1) {
        top: 0px;
        left: 50px;
      }
      li:nth-child(2) {
        top: 250px;
        left: -80px;
      }
      li:nth-child(3) {
        top: 250px;
        right: -80px;
      }
      li {
        position: absolute;
        width: 200px;
        height: 80px;
        line-height: 80px;
        background: rgba(0, 58, 110, 0.85);
        border-radius: 14px;
        color: #02dcfc;
        font-size: 40px;
        font-weight: 700;
      }
    }
  }
}
@keyframes pointLight {
  0% {
    box-shadow: 0 0 1px 0 rgba(0, 255, 255, 0.8);
  }
  100% {
    box-shadow: 0 0 50px 0 rgba(0, 255, 255, 0.8);
    background-color: #aff;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mainMap/mainMap.vue